import { render, staticRenderFns } from "./AbsencePrompt.vue?vue&type=template&id=bff9e904&"
import script from "./AbsencePrompt.vue?vue&type=script&lang=js&"
export * from "./AbsencePrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports